import React from "react";


import GridItem from "../../partials/gridItem";
import { serverUrl, client } from "../../config";
import FavouriteBtn from "../../partials/favouriteBtn";

export default function PollItem(props) {

  const src = client === 'equans' ? `${serverUrl}/${props.item.uri}` : `${serverUrl}/${props.item.field_image}`;

  return (
    <GridItem
      xs={12}
      sm={6}
      md={3}
      itemClass="poll"
      hasImg={true}
      imgSrc={src}
      title={props.item.question}
      field_body={props.item.field_body}
      category_label={props.item?.category_label ? props.item.category_label : props.item.field_category_1}
      created={props.item.created}
      cardAction={true}
      cardActionCallBack={() =>
        props.showPoll(props.item.id, props.item.question)
      }
    >
    </GridItem>
  );
}
